var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
var FavouriteBet = /** @class */ (function (_super) {
    __extends(FavouriteBet, _super);
    function FavouriteBet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._timeout1 = null;
        _this.state = {
            saved: false
        };
        _this.handleKeyPress = function (e) {
            if (e.target.value.length !== 0 && !isNaN(e.target.value)) {
                if (e.charCode === 13) {
                    _this.onSaveBetAmount(e);
                }
            }
        };
        _this.onBlur = function (e) {
            if (e.target.value.length !== 0 && !isNaN(e.target.value)) {
                if (_this.props.value !== e.target.value) {
                    _this.onSaveBetAmount(e);
                }
            }
            else {
                e.target.value = _this.props.value;
            }
        };
        _this.onSaveBetAmount = function (target) {
            _this.props.saveFavourite(target);
            _this.setState({
                saved: true
            });
            _this._timeout1 = setTimeout(function () { return _this.setState({
                saved: false
            }); }, 500);
        };
        return _this;
    }
    FavouriteBet.prototype.render = function () {
        return (_jsxs("div", __assign({ className: 'fav-stake-input' }, { children: [_jsx("input", { name: this.props.name, className: 'fstake-input', type: 'tel', pattern: '[0-9]*', maxLength: '7', onClick: function (e) { return e.target.value = ''; }, defaultValue: this.props.value, onBlur: this.onBlur, onKeyPress: this.handleKeyPress }), _jsx("span", __assign({ className: this.state.saved ? 'active' : '' }, { children: "\u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043E" }))] })));
    };
    return FavouriteBet;
}(React.PureComponent));
FavouriteBet.propTypes = {
    saveFavourite: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
};
export default FavouriteBet;



// WEBPACK FOOTER //
// ./src/components/sidebar/FavouriteBet.jsx